// extracted by mini-css-extract-plugin
module.exports = {"container":"_d2308151","visuallySimilarWrapper":"_d25b4fe5 _f0ada844"};